import CampaignService from '@forwardflow/services/CampaignService'
import { usePhoneNumberUnavailableModalStore } from '@forwardflow/store/modal/phoneNumberUnavailableModal'
import { message, Modal } from 'antd'
import { useParams } from 'react-router-dom'

export const PhoneNumberUnavailableModal = () => {
   const title = useParams().title

   const {
      unavailablePhoneNumbers,
      isPhoneNumberUnavailableModalOpen,
      closePhoneNumberUnavailableModal,
      setUnavailablePhoneNumbers,
   } = usePhoneNumberUnavailableModalStore()

   const onRemoveCampaignPhoneNumber = async (
      LeadSource: string,
      phoneNumber: string
   ) => {
      try {
         await CampaignService.removeCampaignPhoneNumber(
            LeadSource,
            phoneNumber
         )

         message.success(`${phoneNumber} removed successfully`)
      } catch (error) {
         console.error('Failed to remove phone number:', error)
         message.error('Failed to remove phone number')
      }
   }

   const onReplaceNumbers = async () => {
      if (unavailablePhoneNumbers?.length) {
         try {
            for (const number of unavailablePhoneNumbers) {
               await onRemoveCampaignPhoneNumber(title as string, number)
            }

            setUnavailablePhoneNumbers([])
         } catch (error) {
            console.error('Failed to remove unavailable phone numbers:', error)
         }
      }
      closePhoneNumberUnavailableModal()
   }

   return (
      <>
         <Modal
            className="ff-modal"
            title={
               unavailablePhoneNumbers?.length === 1
                  ? `Phone number unavailable`
                  : `Phone numbers unavailable`
            }
            open={isPhoneNumberUnavailableModalOpen}
            onCancel={closePhoneNumberUnavailableModal}
            footer={null}
         >
            <p className="mt-5 mb-14">
               {unavailablePhoneNumbers?.length}{' '}
               {unavailablePhoneNumbers?.length === 1
                  ? 'number has become unavailable. Please replace it before activating.'
                  : 'numbers have become unavailable. Please replace them before activating'}
            </p>
            <div className="flex justify-between py-2 mb-6 bg-primary/10 px-7">
               <div>
                  <p className="mb-2">
                     {unavailablePhoneNumbers?.length === 1
                        ? 'Unavailable number:'
                        : 'Unavailable numbers:'}
                  </p>
                  {unavailablePhoneNumbers?.map((number, index) => (
                     <p key={index}>{number}</p>
                  ))}
               </div>
            </div>
            <button
               onClick={onReplaceNumbers}
               className="w-full h-12 font-semibold transition-all border rounded bg-danger/20 hover:bg-danger/50 border-danger"
            >
               {unavailablePhoneNumbers?.length === 1
                  ? 'Replace number'
                  : 'Replace numbers'}
            </button>
            <button
               onClick={closePhoneNumberUnavailableModal}
               className="w-full h-12 mt-2 font-semibold transition-all border rounded border-white/20 hover:bg-white/10"
            >
               Cancel
            </button>
         </Modal>
      </>
   )
}
